<script setup lang="ts">
import Typography from '@components/Typography.vue';
import Button from '@components/Button.vue';
import Icon from '@components/Icon.vue';
import {
  IconArrowClockwiseFill,
  IconBellRingingFill,
  IconMagnifyingGlass,
} from '@icons';
import { trans } from '@tools/translation.ts';
</script>

<template>
  <div
    :class="[
      'search-empty-state',
      'pt-14',
      'flex flex-col items-center',
    ]"
  >
    <div class="flex items-center gap-x-4">
      <Icon
        :svg="IconMagnifyingGlass"
        width="32"
        height="32"
        fill="gray-darker"
      />

      <Typography
        variant="content-heading-1"
        color="gray-darker"
      >
        {{ trans('search.empty_state.title') }}
      </Typography>
    </div>

    <Typography
      variant="body"
      color="gray-dark"
      class="!mt-4 text-center"
    >
      {{ trans('search.empty_state.advice.1') }}
      <br>{{ trans('search.empty_state.advice.2') }}
    </Typography>

    <Button
      variant="primary"
      class="search-empty-state__btn mt-8"
    >
      <Icon
        :svg="IconArrowClockwiseFill"
        width="24"
        height="24"
        fill="white"
      />

      <span>
        {{ trans('search.empty_state.button.reset') }}
      </span>
    </Button>

    <Button
      variant="inverted"
      class="search-empty-state__btn mt-6"
    >
      <Icon
        :svg="IconBellRingingFill"
        width="24"
        height="24"
        fill="blue"
      />

      <span>
        {{ trans('search.empty_state.button.alert') }}
      </span>
    </Button>
  </div>
</template>

<style lang="scss" scoped>
.search-empty-state {
  &__btn {
    @apply w-fit;

    @apply flex items-center gap-x-2;
  }
}
</style>
